import { render, staticRenderFns } from "./Cta.vue?vue&type=template&id=23bd89f7&scoped=true&"
import script from "./Cta.vue?vue&type=script&lang=js&"
export * from "./Cta.vue?vue&type=script&lang=js&"
import style0 from "./Cta.vue?vue&type=style&index=0&id=23bd89f7&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23bd89f7",
  null
  
)

export default component.exports